module.exports = require('./createEphemeralAuthableStore')
